export default "/images/chevrons-down.svg?16db08d1348acd7058b6542f32a389f5";